export type AppEvent = 'apiMutationError' | 'apiFetchError';

export const APP_EVENTS: { [key in AppEvent]: AppEvent } = {
  apiMutationError: 'apiMutationError',
  apiFetchError: 'apiFetchError',
};
